import { createAction, createActions } from "redux-actions";
import { change, initialize, focus } from "redux-form";
import Session from "session";
import {
  OMS_BASE_PLAN,
  OMS_GUEST_ORDER,
  OMS_DELIVERY_SLOTS,
  OMS_POST_OFFICE_DELIVERY_SLOTS,
  PLAN_SWITCH_CREATE_REQUEST,
  OMS_CREATE_ORDER_TEMP,
  OMS_CREATE_SAD_ORDER,
  OMS_CONFIRM_PAYMENT_OPTION,
  OMS_PAYMENT_RETURN,
  OMS_UPLOAD_IMAGE,
  OMS_UPLOAD_SCREENSHOT,
  OMS_VALIDATE_REFERRAL_CODE,
  OMS_SEARCH_ADDRESS_LOOKUP,
  OMS_ADDRESS_COMPONENT_MAPPINGS,
  OMS_VERIFY_IDENTITY,
  OMS_REQUEST_OTP,
  OMS_VERIFY_OTP,
  OMS_SUBMIT_SUSPENSION,
  OMS_CANCEL_SUSPENSION,
  OMS_SUBMIT_NUMBER_CHANGE,
  OMS_CANCEL_NUMBER_CHANGE,
  OMS_SUSPENSION_PAYMENT_DETAILS,
  OMS_SUBMIT_TERMINATION,
  OMS_SUBMIT_WINBACK,
  OMS_CANCEL_TERMINATION,
  OMS_DELIVERY_INFO,
  OMS_SUBMIT_REPLACE_SIM,
  OMS_SUBMIT_DELIVERY,
  OMS_ORDER_DETAILS,
  VALIDATE_PORT_IN_NUMBER_AND_TELCO,
  OMS_UPLOAD_IDENTITY_DETAILS,
  OMS_SUBMIT_UPLOAD_IDENTITY,
  OMS_PROCESS_PREPAID_ORDER,
  OMS_VALIDATE_ICCID,
  OMS_FETCH_PAYMENT_REQUEST,
  OMS_VERIFY_PAYMENT,
  OMS_DO_KYC,
  OMS_FETCH_SURVEY,
  OMS_GET_CITY_LIST,
  OMS_GET_DISTRICT_LIST,
  OMS_GET_STREET_LIST,
  OMS_GET_STORE_LIST,
  OMS_FIND_ADDRESS_LOOKUP,
  OMS_TRANSACTION_DETAILS,
  OMS_ACTIVATE_SIM_CARD,
  OMS_REINITIATE_PORT_IN,
  OMS_RESCHEDULE_PORT_IN,
  OMS_CANCEL_PORT_IN,
  OMS_IDENTITY_VERIFICATION_STATUS,
  USER_SERVICE_SIGNUP_GENERATE_OTP,
  USER_SERVICE_SIGNUP_RESEND_OTP,
  USER_SERVICE_LOGIN_RESEND_OTP,
  USER_SERVICE_SIGNUP_VALIDATE_OTP,
  USER_SERVICE_LOGIN_VALIDATE_OTP,
  USER_SERVICE_LOGIN,
  USER_SERVICE_AUTHENTICATE,
  DEFAULT_ANALYTICS_PREFERENCES,
  BASE,
  USER_SERVICE_LIQUID_URL,
  USER_SERVICE_LIQUID_OCR_DATA,
  USER_SERVICE_LIQUID_OCR_REGISTER,
  USER_SERVICE_LOGGEDIN_USER_DETAILS,
  OMS_PHONES,
  OMS_CUSTOMER_INFO,
  OMS_USER_WALLET,
  USE_API_GATEWAY,
  API_GATEWAY_CREATE_ORDER,
  API_GATEWAY_UPDATE_ORDER,
  API_GATEWAY_PAYMENT_REQUEST,
  API_GATEWAY_MANAGE_ORDER,
  CREATE_PORTOUT_REQUEST,
  USER_SERVICE_VALIDATE_OTP_TRIGGER,
  USER_SERVICE_VALIDATE_OTP,
  USER_SERVICE_UPDATE_EMAIL,
  USER_SERVICE_LOGOUT,
  API_GATEWAY_ESIM_QR,
  PROCESS_PAYMENT_METHOD,
  PROCESS_CARD_UPDATE_PAYMENT_METHOD,
  SAVE_AND_GET_CARD_DETAILS_CXOS,
  UPFRONT_PAYMENT,
  API_GATEWAY_ACTIVATE_SIM_CARD,
  LOGISTIC_DELIVERY_SLOTS,
  TELCO_PROFILE,
  API_GATEWAY_BASE_PLAN,
  API_GATEWAY_INITIATE_PORTIN,
  API_GATEWAY_CANCEL_PORT_IN,
  API_GATEWAY_SUBMIT_WINBACK,
  API_GATEWAY_SUBMIT_TERMINATION,
  API_GATEWAY_CANCEL_TERMINATION,
  API_GATEWAY_PAYMENT_DETAILS,
  API_GATEWAY_PAYMENT_VERIFY,
  REWARDS_VALIDATE_REFERRAL_CODE,
  API_GATEWAY_DOWNLOAD_SERVICE_AGREEMENT,
  API_GATEWAY_SUBMIT_DELIVERY,
  TELCO_REPORT_LOST_SIM,
  OMS_JUMIO_VERIFICATION_URL,
  OMS_UPDATE_SAD_ORDER,
  OMS_EKYC_COMPLETED,
  OMS_FETCH_ORDER_STATUS,
  OMS_SAD_VALIDATE_ICCID,
  QUILT_ELIGIBILITY,
  REVERSE_PORTIN,
  API_GATEWAY_DELIVERY_DETAILS,
  API_GATEWAY_REQUEST_OTP,
  API_GATEWAY_ORDER_CANCELLATION,
  TELCO_REQUEST_TERMINATE,
  TELCO_EMAIL_SERVICE_AGREEMENT,
  CANCEL_TERMINATION,
  USER_SERVICE_USER_KYC,
  USER_SERVICE_SUBMIT_USER_KYC,
  USER_SERVICE_LINK_SOCIAL,
  QUILT_WINBACK_AGGREGATION,
  QUILT_PROFILE_AGGREGATION,
  API_GATEWAY_ACTIVATE_REPLACE_SIM_CARD,
  OMS_VALIDATE_SIGNATURE,
  OMS_OUTSTANDING_BILLS,
  OMS_CHECK_PAYMENT_STATUS,
  OMS_POP_STATIONS,
  LATITUDE_TRANSACTIONS_STATUS,
  PAYMENT_TRANSACTION_STATUS,
  CIS_REQUEST,
  CIS_REQUEST_HR,
  OMS_PAY_OUTSTANDING_BILLS,
  OMS_AUTHORIZE_ORDER,
  OMS_SET_AUTHORIZE_ORDER,
  OMS_RESEND_ESIM_QR_CODE,
  OMS_SUBMIT_SWITCH_TO_ESIM,
  OMS_SECURED_FETCH_PAYMENT_REQUEST,
  OMS_MYINFO,
  OMS_MYINFO_OTP,
  OMS_MYINFO_VERIFY_OTP,
  CIS_PARTNERS,
  CIS_PARTNERS_REWARDS_FORM_FIELDS,
  CIS_PARTNERS_CMS_FORM_FIELDS,
  API_GATEWAY_UPDATE_PARENTAL_CONSENT,
  TELCO_RE_INITIATE_NUMBER_PORT_IN,
  API_GATEWAY_RESUBMIT_PORTIN_DETAILS,
  USE_REWARDS_CIS,
  BILL_DETAILS,
  BILL_PAYMENT_INTENT,
  BILL_PAYMENT_STATUS,
  USER_SERVICE_REQUEST_OTP_V4_SECURE,
  USER_SERVICE_EMAIL_OTP,
  USER_SERVICE_VALIDATE_EMAIL_OTP,
  API_GATEWAY_QUILT_APP_SETTINGS,
  API_GATEWAY_V1_GLOBAL_SETTINGS,
  IMS_NUMBERS,
  IMS_NUMBER_LOCK,
  IMS_NUMBERS_CATEGORIES,
  API_GATEWAY_OMS_CANCEL_INCOMPLETE_ORDER,
  USER_SERVICE_MANUAL_EKYC,
  USER_SERVICE_KYC_DETAILS,
  PORTIN_DONOR_TELCO,
  AOL_CANCEL_TERMINATION,
  USER_SERVICE_OTT_GENERATE,
  USER_SERVICE_OTT_RESEND,
  USER_SERVICE_UPDATE_USER_PROFILE,
  API_GATEWAY_GET_ORDER_STATUS,
  POSTAL_CODE_COUNTRY,
  API_GATEWAY_ORDER_CANCELLATION_REASONS,
  API_GATEWAY_GET_CREATE_SIM_REPLACEMENT_ORDER,
  LOGISTIC_DELIVERY_SLOT_DETAILS,
  USER_SERVICE_KYC_CONFIG,
  API_GATEWAY_QUILT_TERMINATION_STATUS,
  USER_SERVICE_ANALYTICS_PREFERENCES,
  API_GATEWAY_FETCH_OUTSTANDING_BILL,
  QUILT_SERVICE_REQUESTS,
  QUILT_ORDER_TERMINATION_REQUEST_DETAILS,
  QUILT_ELIGIBLE_PLAN,
  MOCK_PAYMENT,
  PAYMENT_TRANSACTION_STATUS_CXOS,
  NATIONALITY_LIST,
  LOGISTIC_SELF_PICKUP_STATIONS,
  LOGISTIC_SELF_PICKUP_STATION_ADDRESS,
  LOGISTIC_SHIPPING_METHODS,
  LOGISTIC_SHIPPING_LOCATION_DETAILS,
  LOGISTIC_NUMBER_AND_DELIVERY_SLOT_AVAILABILITY,
  OBJ_RESCHEDULE_DELIVERY,
  API_GATEWAY_RESCHEDULE_ORDER,
  LASS_RESCHEDULE_DELIVERY,
  API_GATEWAY_GET_CANCEL_PLAN_SWITCH_ORDER,
  QUILT_PLAN_SWITCH_REQUEST_DETAILS,
  PLAN_SWITCH_RESUBMIT_KYC,
  PLAN_ADDON_BENEFITS,
  ALL_PROMOTIONS,
  DELIVERY_FEE_SKU,
  REMOVE_PAYMENT_METHOD,
  ADD_NEW_PAYMENT_METHOD,
  UPDATE_DEFAULT_PAYMENT_METHOD,
  ENABLED_PAYMENT_METHODS,
  AOL_TERMINATION_REASONS,
  API_LOCALIZATION,
  PORTIN_MNPCONFIG_TELCO,
  SAVED_PAYMENT_METHODS,
  // LOGISTIC_ADDRESS_MAPPING,
  PROFILE_PARAMETERS,
  CONFIGURATION,
  LOGISTIC_ADDRESS_MAPPING,
  PORT_IN_REQUEST,
  PORTIN_CANCELLATION_ELIGIBILITY,
  CANCEL_PORTIN,
  SUGGESTED_ADDONS,
  API_CONSENT_RECODER,
  E_SIM_DELIVERY_CONFIG,
  ORDER_PREVIEW,
  VALIDATE_PROMO_CODES,
  API_EXTERNAL_PENDING_ORDERS,
  ELIGIBILITY_LINE_PATH,
  USER_SERVICE_GUEST_SIGNUP,
  USER_SERVICE_GUEST_OTT_VALIDATE,
  RE_SUBMIT_KYC_PATH,
  SAVED_PAYMENT_METHOD_REQUEST,
  LASS_RESCHEDULE_SHIPMENT_DELIVERY,
  API_GATEWAY_TRANSCTION_CANCEL,
  USER_LOGIN_GENERATE_OTP,
  WALLET_AUTHENTICATE,
  API_MODULE_LOCALIZATION,
  API_GATEWAY_UPDATE,
  ADDRESS_API_GATEWAY_UPDATE,
  NEW_SAVED_PAYMENT_METHOD_REQUEST,
  SELF_PICKUP_LOCATION_UPDATE,
  LOGISTIC_RETAIL_STORES,
  UNSUBSCRIBE
} from "utils/constants";
import {
  prepareImageDataForUpload,
  prepareScreenshotDataForUpload
} from "utils/helpers";
import { getLocaleOrDefault, isMiniApp } from "utils/localStorage";
import { postcodeValidator } from "postcode-validator";
import Alert from "react-s-alert";

export * from "./uiActions";

export const clearData = createAction("CLEAR_DATA");
export const setData = createAction("SET_DATA");
export const resetLoadingApis = createAction("RESET_LOADING_APIS");
export const clearStore = createAction("CLEAR_STORE");

export const fetchAppSettings = callback => {
  const path = API_GATEWAY_QUILT_APP_SETTINGS;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY_QUILT : BASE.QUILT_SERVICE;
  return fetchRequested({
    key: "appSettings",
    path,
    base,
    callback,
    override: true
  });
};
export const fetchGlobalSettings = callback => {
  const path = API_GATEWAY_V1_GLOBAL_SETTINGS;
  const base = BASE.API_GATEWAY_OBM;
  return fetchRequested({
    key: "appGlobalSettings",
    path,
    base,
    callback,
    override: true
  });
};
export const fetchPaylinkDetails = (paylink, headers) => {
  const path = API_GATEWAY_FETCH_OUTSTANDING_BILL.replace("{paylink}", paylink);
  const base = BASE.PAYMENTS;
  return fetchRequested({
    key: "directPayLinkInfo",
    path,
    base,
    headers,
    override: true
  });
};

export const updatePaylinkAlternateEmail = (
  paylink,
  headers,
  params,
  callback
) => {
  const path = API_GATEWAY_FETCH_OUTSTANDING_BILL.replace("{paylink}", paylink);
  const base = BASE.PAYMENTS;
  return fetchRequested({
    key: "paylinkUpdateEmail",
    path,
    base,
    headers,
    method: "PATCH",
    params,
    callback
  });
};

// export const fetchLocale = callback => {
//   const locale = getLocaleOrDefault();
//   const path = API_GATEWAY_QUILT_LOCALE;
//   const base = USE_API_GATEWAY ? BASE.API_GATEWAY_QUILT : BASE.QUILT_SERVICE;
//   return fetchRequested({
//     key: "locale",
//     path,
//     base,
//     params: { locale },
//     callback
//   });
// };
export const fetchLocale = callback => {
  const langCode = getLocaleOrDefault();
  const component = "WEB";
  const path = API_LOCALIZATION;
  const base = BASE.API_GATEWAY_CXOS_LOCAL;
  return fetchRequested({
    key: "locale",
    path,
    base,
    params: { langCode, component },
    callback
  });
};
export const fetchPlan = (params, callback) => {
  const path = USE_API_GATEWAY ? API_GATEWAY_BASE_PLAN : OMS_BASE_PLAN;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequested({
    key: "planService",
    path,
    base,
    params,
    callback
  });
};

export const fetchEligiblePlans = (params, callback) => {
  const path = QUILT_ELIGIBLE_PLAN;
  const base = BASE.QUILT_SERVICE;
  return fetchRequested({
    key: "eligiblePlans",
    path,
    base,
    params,
    callback,
    override: true
  });
};

export const selectPlan = (data, callback) => {
  return setData({
    key: "planService",
    data,
    callback,
    override: true
  });
};

export const clearPromoCodes = callback => {
  return setData({
    key: "referralCode",
    data: {},
    callback,
    override: true
  });
};

export const fetchNumbers = (params, callback) => {
  const path = IMS_NUMBERS;
  const base = BASE.NEW_IMS;
  return fetchRequested({
    key: "numbers",
    path,
    base,
    params,
    method: "POST",
    version: "v4",
    callback
  });
};

export const selectedNumberCategory = data => {
  return setData({
    key: "selectedNumberCategory",
    data
  });
};

export const filteredNumbers = params => {
  const path = IMS_NUMBERS;
  const base = BASE.NEW_IMS;
  return fetchRequested({
    key: "filteredNumbers",
    path,
    base,
    params,
    method: "POST",
    version: "v4"
  });
};

export const setSearchNumberKey = data => {
  return setData({
    key: "setSearchNumberKey",
    data
  });
};

export const filteredNumbersDetails = (params, callback) => {
  const path = IMS_NUMBERS;
  const base = BASE.NEW_IMS;
  return fetchRequested({
    key: "filteredNumbers",
    path,
    base,
    params,
    method: "POST",
    version: "v4",
    override: true,
    callback
  });
};

export const fetchNumberCategories = () => {
  const path = IMS_NUMBERS_CATEGORIES;
  const base = BASE.NEW_IMS;
  return fetchRequested({
    key: "NumberCategories",
    path,
    base,
    method: "GET",
    version: "v4",
    override: true
  });
};

export const clearFilteredNumberStore = data => {
  return setData({
    key: "filteredNumbers",
    data
  });
};

export const fetchGuestOrder = (params, callback) => {
  const path = USE_API_GATEWAY ? API_GATEWAY_MANAGE_ORDER : OMS_GUEST_ORDER;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "guestOrder",
    path,
    base,
    method: "POST",
    params,
    callback,
    override: true
  });
};

export const fetchAuthorizerDetails = (params, callback) => {
  const path = OMS_AUTHORIZE_ORDER.replace("{id}", params.order_id);
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "authorizerDetails",
    path,
    base,
    method: "GET",
    params,
    callback,
    override: true
  });
};

export const setAuthorizerDetails = (params, callback) => {
  const path = OMS_SET_AUTHORIZE_ORDER.replace("{id}", params.order_id);
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "setAuthorizerDetails",
    path,
    base,
    method: "POST",
    params,
    callback,
    override: true
  });
};

export const fetchUserOrders = (params, callback) => {
  const path = USE_API_GATEWAY ? API_GATEWAY_MANAGE_ORDER : OMS_GUEST_ORDER;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "userOrders",
    path,
    base,
    method: "POST",
    params,
    callback,
    override: true
  });
};

export const fetchExternalPendingOrders = (params, callback) => {
  const { email } = params;
  const path = API_EXTERNAL_PENDING_ORDERS.replace("{email}", email);
  const base = BASE.API_EXTERNAL_ORDERS;
  return fetchRequested({
    key: "externalPendingOrders",
    path,
    base,
    method: "GET",
    callback,
    override: true
  });
};

export const getPortInRequest = params => {
  const path = PORT_IN_REQUEST.replace("{orderRef}", params);
  const base = BASE.API_GATEWAY_PORT_IN;
  return fetchRequested({
    key: "portInRequest",
    path,
    base,
    method: "GET",
    override: true
  });
};

export const portInCancellationEligibility = (params, callback) => {
  const path = PORTIN_CANCELLATION_ELIGIBILITY.replace(
    "{port-in-number}",
    params
  );
  const base = BASE.API_GATEWAY_PORTIN_CANCELLATION_ELIGIBILITY;
  return fetchRequested({
    key: "portInCancellationEligibility",
    path,
    base,
    callback,
    method: "GET",
    override: true
  });
};

export const fetchServiceRequests = (params, callback) => {
  const path = QUILT_SERVICE_REQUESTS.replace("{sin_number}", params);
  const base = BASE.QUILT_SERVICE;
  return fetchRequested({
    key: "serviceRequests",
    path,
    base,
    callback,
    method: "GET",
    override: true
  });
};

export const fetchOrderTerminationStatus = (params, callback) => {
  const path = API_GATEWAY_QUILT_TERMINATION_STATUS;
  const base = BASE.QUILT_SERVICE;
  return fetchRequested({
    key: "orderTerminationStatus",
    path,
    base,
    method: "GET",
    params,
    callback,
    override: true
  });
};

export const fetchOrderTerminationDetails = (params, callback) => {
  const path = QUILT_ORDER_TERMINATION_REQUEST_DETAILS;
  const base = BASE.QUILT_SERVICE;
  return fetchRequested({
    key: "orderTerminationDetails",
    path,
    base,
    method: "GET",
    params,
    callback,
    override: true
  });
};

export const fetchOrderDetails = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "orderDetails",
    path: OMS_ORDER_DETAILS,
    method: "POST",
    params,
    callback
  });
};

export const fetchUploadIdentityDetails = params => {
  return fetchRequested({
    key: "uploadIdentityDetails",
    path: OMS_UPLOAD_IDENTITY_DETAILS,
    method: "POST",
    params
  });
};

export const fetchReferralCode = ({
  referral_code,
  plan_name,
  is_portin,
  plan_type
}) => {
  const params = {
    referral_code,
    plan_name,
    is_portin,
    plan_type
  };
  let path = USE_API_GATEWAY
    ? REWARDS_VALIDATE_REFERRAL_CODE
    : OMS_VALIDATE_REFERRAL_CODE;
  const base = USE_API_GATEWAY ? BASE.REWARDS : BASE.OMS;
  path = path.replace("{REFERRAL_CODE}", referral_code);
  const successData = {
    referral_code
  };
  return fetchRequestedWithCaptcha({
    key: "referralCode",
    path,
    base,
    params,
    successData,
    whitelistedCodes: [400],
    meta: {
      captchaAction: "promos_validate"
    }
  });
};

export const fetchOTP = (params, callback) => {
  const path = USE_API_GATEWAY ? API_GATEWAY_REQUEST_OTP : OMS_REQUEST_OTP;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "requestOTP",
    path,
    base,
    method: "POST",
    params,
    callback
  });
};

export const fetchOTPSecured = (params, callback) => {
  return fetchRequested({
    key: "requestOTPV4",
    base: BASE.USER_SERVICE,
    path: USER_SERVICE_REQUEST_OTP_V4_SECURE,
    method: "POST",
    params,
    callback
  });
};

export const fetchValidateOTP = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "validateOTP",
    base: BASE.USER_SERVICE,
    path: USER_SERVICE_VALIDATE_OTP,
    method: "POST",
    params,
    callback
  });
};

export const fetchValidateOTPTrigger = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "validateOTPTrigger",
    base: BASE.USER_SERVICE,
    path: USER_SERVICE_VALIDATE_OTP_TRIGGER,
    method: "POST",
    params,
    callback
  });
};

export const fetchUpdateNewEmail = (params, callback) => {
  return fetchRequested({
    key: "updateNewEmail",
    base: BASE.USER_SERVICE,
    path: USER_SERVICE_UPDATE_EMAIL,
    method: "PATCH",
    params,
    callback
  });
};

export const fetchPaymentRequestold = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_PAYMENT_REQUEST
    : OMS_FETCH_PAYMENT_REQUEST;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "paymentRequest",
    path,
    base,
    method: "POST",
    params,
    callback
  });
};

const AlertNotification = params => {};
export const paymentNotificationAction = params => () => {
  Alert.success(AlertNotification(params.status));
  if (params.status === "Success") {
    Alert.success(params.message);
  } else {
    Alert.error(params.message);
  }
};
const toastType = {
  Payment_method_id_01: "Gpay Clicked",
  Payment_method_id_02: "EasyPaisa clicked",
  Payment_method_id_03: "JazzCash clicked",
  Payment_method_id_04: "Upaisa clicked"
};

export const paymentEwalletMethodAction = params => () =>
  params.id && Alert.success(toastType[params.id]);

export const fetchSecuredPaymentRequest = params => {
  return fetchRequestedWithCaptcha({
    key: "paymentRequest",
    path: OMS_SECURED_FETCH_PAYMENT_REQUEST,
    method: "POST",
    params
  });
};

export const setEkycCompleted = params => {
  return fetchRequestedWithCaptcha({
    key: "ekyc",
    path: OMS_EKYC_COMPLETED,
    method: "POST",
    params
  });
};

export const fetchOrderStatus = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "orderStatus",
    path: OMS_FETCH_ORDER_STATUS,
    method: "GET",
    params,
    callback
  });
};

export const postPaymentRequest = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_PAYMENT_REQUEST
    : OMS_FETCH_PAYMENT_REQUEST;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "paymentRequest",
    path,
    base,
    method: "POST",
    params,
    callback,
    meta: {
      captchaAction: "payment_request"
    }
  });
};

//TODO need be implemented
export const applePayMerchantValidation = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_PAYMENT_REQUEST
    : OMS_FETCH_PAYMENT_REQUEST;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "applePayMerchantValidationRequest",
    path,
    base,
    method: "POST",
    params,
    callback
  });
};

export const changeFormField = ({ form, field, value }) => {
  return change(form, field, value);
};

export const foucsFormField = ({ form, field }) => {
  console.log("inside focus");
  return focus(form, field);
};

export const initializeForm = ({ form, data, keepDirty = true }) => {
  return initialize(form, data, keepDirty);
};

export const fetchPaymentReturn = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_PAYMENT_DETAILS
    : OMS_PAYMENT_RETURN;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "paymentReturn",
    path,
    base,
    method: "POST",
    params,
    callback,
    meta: {
      captchaAction: "payment_details"
    }
  });
};

export const getSlotDetailsById = (params, callback) => {
  const path = USE_API_GATEWAY
    ? LOGISTIC_DELIVERY_SLOT_DETAILS.replace("{slotID}", params)
    : OMS_DELIVERY_SLOTS;
  const base = USE_API_GATEWAY ? BASE.LOGISTIC : BASE.OMS;
  return fetchRequested({
    key: "slotDetails",
    path,
    base,
    onErrorOverride: true,
    callback
  });
};
export const rescheduleDelivery = (headers, params, callback) => {
  const path = LASS_RESCHEDULE_DELIVERY;
  return fetchRequested({
    key: "rescheduleDelivery",
    path,
    base: BASE.LOGISTIC,
    params,
    headers,
    method: "POST",
    callback,
    version: "v2"
  });
};
export const onboardRescheduleDelivery = (params, callback) => {
  const path = OBJ_RESCHEDULE_DELIVERY;
  return fetchRequested({
    key: "rescheduleDelivery",
    path,
    base: BASE.JOURNEY_MANAGER_URL,
    params,
    method: "POST",
    callback,
    version: "v2"
  });
};

export const checkEligibilityLines = (params, callback) => {
  return fetchRequested({
    key: "checkEligibilityLines",
    path: ELIGIBILITY_LINE_PATH,
    base: BASE.JOURNEY_MANAGER_URL,
    params,
    onErrorOverride: true,
    method: "POST",
    callback,
    version: "v1"
  });
};

export const fetchDeliverySlots = (params, callback) => {
  const path = USE_API_GATEWAY ? LOGISTIC_DELIVERY_SLOTS : OMS_DELIVERY_SLOTS;
  const base = USE_API_GATEWAY ? BASE.LOGISTICS : BASE.OMS;
  return fetchRequested({
    key: "deliverySlots",
    path,
    base,
    params,
    callback,
    onErrorOverride: true,
    whitelistedCodes: [4220310]
  });
};

export const fetchSelfPickupStations = (params, callback) => {
  const base = BASE.LOGISTIC;
  const path = LOGISTIC_SELF_PICKUP_STATIONS.replace("{zipcode}", params);
  return fetchRequested({
    key: "selfPickupStations",
    path,
    base,
    override: true,
    onErrorOverride: true,
    callback
  });
};

export const fetchRetailStores = (params, callback) => {
  const base = BASE.LOGISTIC;
  const path = LOGISTIC_RETAIL_STORES.replace("{storeId}", params);
  return fetchRequested({
    key: "retailStores",
    path,
    base,
    override: true,
    onErrorOverride: true,
    callback
  });
};

export const fetchSelfPickupStationsAction = payload => {
  const { lat, lng, count } = payload;
  const base = BASE.LOGISTICS;
  const path = LOGISTIC_SELF_PICKUP_STATION_ADDRESS.replace("{lat}", lat)
    .replace("{lng}", lng)
    .replace("{count}", count);
  return fetchRequested({
    key: "selfPickupStationsAddress",
    path,
    base,
    override: true,
    onErrorOverride: true
  });
};

export const fetchShippingMethods = () => {
  const base = BASE.LOGISTIC;
  const path = LOGISTIC_SHIPPING_METHODS;
  return fetchRequested({
    key: "shippingMethods",
    path,
    base,
    override: true
  });
};

export const fetchShippingLocationDetails = params => {
  const base = BASE.LOGISTIC;
  const path = LOGISTIC_SHIPPING_LOCATION_DETAILS.replace(
    "{pickupLocationId}",
    params
  );
  return fetchRequested({
    key: "shippingLocationDetails",
    path,
    base,
    override: true
  });
};

export const fetchPostOfficeDeliverySlots = params => {
  return fetchRequested({
    key: "postOfficeDeliverySlots",
    path: OMS_POST_OFFICE_DELIVERY_SLOTS,
    params,
    override: true
  });
};

export const fetchAddressLookup = params => {
  return fetchRequested({
    key: "addressLookup",
    path: OMS_SEARCH_ADDRESS_LOOKUP,
    params
  });
};

export const fetchAddressComponentMappings = params => {
  return fetchRequested({
    key: "addressComponentMappings",
    path: OMS_ADDRESS_COMPONENT_MAPPINGS,
    params,
    override: true
  });
};

export const findAddressLookup = (params, callback) => {
  return fetchRequested({
    key: "addressComponentMappings",
    path: OMS_FIND_ADDRESS_LOOKUP,
    params,
    callback,
    override: true
  });
};

export const fetchSuspensionPaymentDetails = params => {
  return fetchRequested({
    key: "suspensionPaymentDetails",
    path: OMS_SUSPENSION_PAYMENT_DETAILS,
    params
  });
};
export const verifyRescheduleDelivery = (params, callback) => {
  const path = API_GATEWAY_RESCHEDULE_ORDER;
  const base = BASE.API_GATEWAY_CXOS;
  return fetchRequested({
    key: "rescheduleVerificationStatus",
    path,
    base,
    params,
    callback
  });
};

export const fetchDeliveryDetails = params => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_DELIVERY_DETAILS
    : OMS_DELIVERY_INFO;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequested({
    key: "scheduleDeliveryDetails",
    path,
    base,
    params
  });
};

export const fetchProfileParameters = () => {
  return fetchRequested({
    key: "newProfileParameters",
    // base: BASE.API_GATEWAY,
    base: BASE.CONFIG_API,
    path: PROFILE_PARAMETERS,
    method: "GET"
  });
};
/* Commenting for 14557 reversal state defect*/
export const fetchDeliveryLocationAddressList = (params, headers) => {
  return fetchRequested({
    key: "addressList",
    base: BASE.LOGISTIC,
    params,
    path: LOGISTIC_ADDRESS_MAPPING,
    method: "GET",
    version: "v1",
    headers
  });
};

export const fetchTransactionDetails = (params, callback) => {
  return fetchRequested({
    key: "transactionDetails",
    path: OMS_TRANSACTION_DETAILS,
    params,
    callback
  });
};

export const numberLock = (params, callback) => {
  const path = IMS_NUMBER_LOCK.replace("{number}", params?.number);
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.IMS;
  return fetchRequested({
    key: "lockedNumber",
    path,
    base,
    params,
    callback,
    method: "POST",
    version: "v2"
  });
};
export const setSelectedNumberPrice = price => {
  return setData({
    key: "selectedNumberPriceDetails",
    data: price
  });
};

export const uploadImage = payload => {
  const [primaryOrSecondary, frontOrBack, file, binaryStr] = payload;
  const reference_number = Session.getDeviceId();
  const params = { reference_number };
  params[`${frontOrBack}_image`] = prepareImageDataForUpload(file, binaryStr);

  return fetchRequested({
    key: `${primaryOrSecondary}_${frontOrBack}_ImagesUpload`,
    params,
    path: OMS_UPLOAD_IMAGE,
    merge: { reference_number },
    method: "POST"
  });
};

export const uploadSignature = binaryStr => {
  const file = { name: "eSignature.png" };

  const reference_number = Session.getDeviceId();
  const params = {
    reference_number,
    esignImage: prepareImageDataForUpload(file, binaryStr)
  };

  return fetchRequested({
    key: "eSignature",
    params,
    path: OMS_UPLOAD_IMAGE,
    merge: { reference_number },
    method: "POST"
  });
};

export const uploadScreenshot = payload => {
  const { screenshot } = payload;
  const reference_number = Session.getDeviceId();

  const name = "screenshot_of_consent";
  const file = { name };
  const params = {
    reference_number,
    ...prepareScreenshotDataForUpload(file, screenshot)
  };

  return fetchRequested({
    key: "screenshot",
    params,
    path: OMS_UPLOAD_SCREENSHOT,
    merge: { reference_number },
    method: "POST"
  });
};

export const verifyIdentity = (params, callback) => {
  return fetchRequested({
    key: "verifyIdentity",
    path: OMS_VERIFY_IDENTITY,
    params,
    method: "POST",
    callback
  });
};

export const identityVerificationStatus = (params, callback) => {
  return fetchRequested({
    key: "identityVerificationStatus",
    path: OMS_IDENTITY_VERIFICATION_STATUS,
    params,
    method: "POST",
    callback
  });
};

export const validatePortInNumber = (params, callback) => {
  return fetchRequested({
    base: BASE.JOURNEY_MANAGER_URL,
    key: "validatePortInNumber",
    path: VALIDATE_PORT_IN_NUMBER_AND_TELCO,
    params,
    callback,
    onErrorOverride: true
  });
};

export const validatePostalCode = (params, field, callback) => {
  return fetchSucceeded({
    key: `validatePostalCode.${field}`,
    data: {
      status: postcodeValidator(params.postal_code, POSTAL_CODE_COUNTRY)
    }
  });
};

export const resetPortInNumberValidation = () =>
  clearData("validatePortInNumber");

export const resetDeliverySlots = () => clearData("deliverySlots");

export const resetPostalCodeValidation = field =>
  clearData(`validatePostalCode.${field}`);

export const setPostalCodeValidation = (field, data = {}, loading) =>
  setData({ key: `validatePostalCode.${field}`, data, loading });

export const verifyOTP = (params, callback) => {
  return fetchRequested({
    key: "verifyOTP",
    params,
    path: OMS_VERIFY_OTP,
    method: "POST",
    callback
  });
};

export const submitNumberChange = (params, callback) => {
  return fetchRequested({
    key: "submitNumberChange",
    params,
    path: OMS_SUBMIT_NUMBER_CHANGE,
    method: "POST",
    callback
  });
};

export const submitCancelNumberChange = (params, callback) => {
  return fetchRequested({
    key: "cancelNumberChange",
    params,
    path: OMS_CANCEL_NUMBER_CHANGE,
    method: "POST",
    callback
  });
};

export const submitSuspension = (params, callback) => {
  return fetchRequested({
    key: "submitSuspension",
    params,
    path: OMS_SUBMIT_SUSPENSION,
    method: "POST",
    callback
  });
};

export const submitCancelSuspension = (params, callback) => {
  return fetchRequested({
    key: "cancelSuspension",
    params,
    path: OMS_CANCEL_SUSPENSION,
    method: "POST",
    callback
  });
};

export const submitScheduleDelivery = (params, callback) => {
  return fetchRequested({
    key: "submitScheduleDelivery",
    params,
    path: OMS_SUBMIT_DELIVERY,
    method: "POST",
    callback
  });
};

export const submitAuthorizeDelivery = (params, callback) => {
  const path = OMS_SET_AUTHORIZE_ORDER.replace("{id}", params.order_id);
  return fetchRequested({
    key: "submitAuthorizeDelivery",
    params,
    path,
    method: "POST",
    callback
  });
};

export const submitReplaceSim = (params, callback) => {
  return fetchRequested({
    key: "submitReplaceSim",
    params,
    path: OMS_SUBMIT_REPLACE_SIM,
    method: "POST",
    callback
  });
};

export const submitReplaceSimToTelco = (headers, params, callback) => {
  const path = TELCO_REPORT_LOST_SIM;
  const base = BASE.TELCO_SERVICE;
  return fetchRequested({
    key: "submitReplaceSimToTelco",
    headers,
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const submitSwitchToEsim = (params, callback) => {
  return fetchRequested({
    key: "submitSwitchToEsim",
    params,
    path: OMS_SUBMIT_SWITCH_TO_ESIM,
    method: "POST",
    callback
  });
};

export const submitResendEsimQR = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "resendEsimQRCode",
    params,
    path: OMS_RESEND_ESIM_QR_CODE,
    method: "POST",
    callback
  });
};

export const submitTermination = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_SUBMIT_TERMINATION
    : OMS_SUBMIT_TERMINATION;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequested({
    key: "submitTermination",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const submitWinback = (params, callback) => {
  const path = API_GATEWAY_SUBMIT_WINBACK;
  const base = BASE.REWARDS_SERVICE;
  return fetchRequested({
    key: "submitWinback",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const cancelTermination = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_CANCEL_TERMINATION
    : OMS_CANCEL_TERMINATION;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequested({
    key: "cancelTermination",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const submitUploadIdentity = (params, callback) => {
  return fetchRequested({
    key: "submitUploadIdentity",
    params,
    path: OMS_SUBMIT_UPLOAD_IDENTITY,
    method: "POST",
    callback
  });
};

export const validateIccId = (params, callback) => {
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "validateIccId",
    params,
    path: OMS_VALIDATE_ICCID,
    base,
    callback,
    whitelistedCodes: [422]
  });
};

export const validateIccIdForSelfActivation = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "validateIccId",
    params,
    path: OMS_SAD_VALIDATE_ICCID,
    method: "POST",
    callback,
    whitelistedCodes: [422]
  });
};

// what is this? @veera
export const mockPayment = (params, callback) => {
  return fetchRequested({
    key: "mockPayment",
    params,
    path: OMS_PROCESS_PREPAID_ORDER,
    method: "POST",
    callback
  });
};

export const createInitialOrder = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_CREATE_ORDER
    : OMS_CREATE_ORDER_TEMP;
  const base = BASE.ONIC_BASE;
  return fetchRequestedWithCaptcha({
    key: "order",
    params,
    path,
    base,
    method: "POST",
    callback,
    meta: {
      captchaAction: "create_order"
    },
    version: "v3" // need to change to "v3"
  });
};

export const createSimReplacementOrder = (headers, params, callback) => {
  const path = API_GATEWAY_GET_CREATE_SIM_REPLACEMENT_ORDER;
  const base = BASE.ONIC_BASE;
  return fetchRequestedWithCaptcha({
    key: "order",
    params,
    headers,
    path,
    base,
    method: "POST",
    version: "v3",
    callback,
    multiPartForm: true,
    meta: {
      captchaAction: "create_order"
    }
  });
};

export const getOrderStatus = (params, callback) => {
  const path = API_GATEWAY_GET_ORDER_STATUS.replace("{orderRef}", params);
  const base = BASE.API_GATEWAY_CXOS;
  return fetchRequestedWithCaptcha({
    key: "order",
    path,
    base,
    method: "GET",
    callback
  });
};

export const getOrderPaymentStatus = (params, callback) => {
  const path = API_GATEWAY_GET_ORDER_STATUS.replace("{orderRef}", params);
  const base = BASE.API_GATEWAY_CXOS;
  return fetchRequestedWithCaptcha({
    key: "order",
    path,
    base,
    method: "GET",
    callback
  });
};

export const updateOrder = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_UPDATE_ORDER
    : OMS_CREATE_ORDER_TEMP;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "order",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const updateSadOrder = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "order",
    params,
    path: OMS_UPDATE_SAD_ORDER,
    method: "PUT",
    callback
  });
};

export const updateLatitudePaymentStatus = (params, callback) => {
  return fetchRequested({
    key: "updateLatitudePaymentStatus",
    params,
    base: BASE.PAYMENTS_SERVICE,
    path: LATITUDE_TRANSACTIONS_STATUS,
    method: "POST",
    callback
  });
};

export const getJumioVerificationUrl = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "jumio",
    params,
    path: OMS_JUMIO_VERIFICATION_URL,
    method: "GET",
    callback
  });
};

export const confirmPaymentOption = (params, callback) => {
  return fetchRequested({
    key: "confirmPaymentOption",
    params,
    path: OMS_CONFIRM_PAYMENT_OPTION,
    method: "POST",
    callback
  });
};

export const verifyPayment = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_PAYMENT_VERIFY
    : OMS_VERIFY_PAYMENT;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequested({
    key: "verifyPayment",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const doKyc = (params, callback) => {
  return fetchRequested({
    key: "kyc",
    params,
    path: OMS_DO_KYC,
    method: "POST",
    callback
  });
};

export const activateSimCard = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_ACTIVATE_SIM_CARD
    : OMS_ACTIVATE_SIM_CARD;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY_CXOS : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "activateSimCard",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const activateReplaceSimCard = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_ACTIVATE_REPLACE_SIM_CARD
    : OMS_ACTIVATE_SIM_CARD;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequestedWithCaptcha({
    key: "lostSimActivate",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const initiatePortIn = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_INITIATE_PORTIN
    : OMS_ACTIVATE_SIM_CARD;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequested({
    key: "initiatePortIn",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const reinitiatePortIn = (params, callback) => {
  return fetchRequested({
    key: "reinitiatePortIn",
    params,
    path: OMS_REINITIATE_PORT_IN,
    method: "POST",
    callback
  });
};

export const reschedulePortIn = (params, callback) => {
  return fetchRequested({
    key: "reschedulePortIn",
    params,
    path: OMS_RESCHEDULE_PORT_IN,
    method: "POST",
    callback
  });
};

export const cancelPortIn = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_CANCEL_PORT_IN
    : OMS_CANCEL_PORT_IN;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;
  return fetchRequested({
    key: "cancelPortIn",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const createSelfActivationDeliveryOrder = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "selfActivationDeliveryOrder",
    params,
    path: OMS_CREATE_SAD_ORDER,
    method: "POST",
    callback
  });
};

export const fetchSurvey = params => {
  return fetchRequested({ key: "survey", path: OMS_FETCH_SURVEY, params });
};

export const fetchCityList = params => {
  return fetchRequested({ key: "cityList", path: OMS_GET_CITY_LIST, params });
};

export const fetchDistrictList = ({ city }) => {
  return fetchRequested({
    key: "districtList",
    path: OMS_GET_DISTRICT_LIST,
    params: { city }
  });
};

export const fetchStreetList = ({ city, district }) => {
  return fetchRequested({
    key: "streetList",
    path: OMS_GET_STREET_LIST,
    params: { city, district }
  });
};

export const fetchStoreList = ({
  city,
  district,
  street,
  portin = false,
  type = "sim-only"
}) => {
  return fetchRequested({
    key: "storeList",
    path: OMS_GET_STORE_LIST,
    params: { city, district, street, portin, type }
  });
};

export const fetchPhones = (params, callback) => {
  return fetchRequested({
    key: "phones",
    path: OMS_PHONES,
    params,
    callback
  });
};

export const fetchCustomerInfo = (params, callback) => {
  return fetchRequested({
    key: "customerInfo",
    params,
    path: OMS_CUSTOMER_INFO,
    method: "POST",
    callback
  });
};

export const fetchUserWallet = (params, callback) => {
  return fetchRequested({
    key: "wallet",
    params,
    path: OMS_USER_WALLET,
    method: "POST",
    callback
  });
};

export const userLoginAction = (headers, params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "userLogin",
    base: BASE.USER_SERVICE,
    headers,
    params,
    path: USER_SERVICE_LOGIN,
    method: "POST",
    callback,
    meta: {
      captchaAction: "Login"
    }
  });
};

export const fetchLiquidUrl = (params, callback) => {
  return fetchRequested({
    key: "liquidURL",
    base: BASE.USER_SERVICE,
    params,
    path: USER_SERVICE_LIQUID_URL,
    method: "POST",
    callback
  });
};

export const getLiquidOcrData = (orderRef, callback) => {
  const path = `${USER_SERVICE_LIQUID_OCR_DATA}/${orderRef}`;
  const successData = { orderRef };

  return fetchRequested({
    key: "liquidOcrData",
    base: BASE.USER_SERVICE,
    path,
    callback,
    successData
  });
};

export const registerOcrData = (params, callback) => {
  return fetchRequested({
    key: "liquidOCRRegister",
    base: BASE.USER_SERVICE,
    params,
    method: "POST",
    path: USER_SERVICE_LIQUID_OCR_REGISTER,
    callback
  });
};

export const userLoginOTP = (
  headers,
  params,
  callback,
  isSignupType = true
) => {
  const baseUrl = isSignupType ? BASE.USER_SERVICE : BASE.ONIC_BASE;
  const path = isSignupType
    ? USER_SERVICE_SIGNUP_GENERATE_OTP
    : USER_LOGIN_GENERATE_OTP;
  return fetchRequested({
    key: "userLoginOTP",
    base: baseUrl,
    headers,
    params,
    path,
    method: "POST",
    callback
  });
};

export const userResendOTP = (
  headers,
  params,
  callback,
  isSignupType = true
) => {
  const path = isSignupType
    ? USER_SERVICE_SIGNUP_RESEND_OTP
    : USER_SERVICE_LOGIN_RESEND_OTP;
  return fetchRequested({
    key: "userLoginOTP",
    base: BASE.USER_SERVICE,
    headers,
    params,
    path,
    method: "POST",
    callback
  });
};

export const userAuthenticateOTP = (
  headers,
  params,
  callback,
  isSignupType = true
) => {
  const path = isSignupType
    ? USER_SERVICE_SIGNUP_VALIDATE_OTP
    : USER_SERVICE_LOGIN_VALIDATE_OTP;
  return fetchRequested({
    key: "userAuthenticate",
    base: BASE.USER_SERVICE,
    headers,
    params,
    path,
    method: "POST",
    callback
  });
};

export const userAuthenticate = (headers, params, callback) => {
  return fetchRequested({
    key: "userAuthenticate",
    base: BASE.USER_SERVICE,
    headers,
    params,
    path: USER_SERVICE_AUTHENTICATE,
    method: "POST",
    callback
  });
};

export const fetchLoggedInUserDetails = (headers, params, callback) => {
  return fetchRequested({
    key: "loggedInUserDetails",
    base: BASE.ONIC_BASE,
    headers,
    params,
    path: USER_SERVICE_LOGGEDIN_USER_DETAILS,
    callback,
    version: "v6"
  });
};

export const fetchUserProfileDetails = params => {
  return fetchRequested({
    key: "userProfileDetails",
    base: BASE.QUILT_SERVICE,
    path: QUILT_PROFILE_AGGREGATION,
    params
  });
};

export const requestMNPReservationNumber = (headers, params, callback) => {
  return fetchRequested({
    key: "requestMNPReservationNumber",
    base: BASE.TELCO_SERVICE,
    headers,
    params,
    path: CREATE_PORTOUT_REQUEST,
    method: "POST",
    callback
  });
};

export const fetchEsimQR = (headers, params, callback) => {
  return fetchRequested({
    key: "esimQR",
    base: BASE.API_GATEWAY,
    headers,
    params,
    path: API_GATEWAY_ESIM_QR,
    method: "POST",
    callback,
    mediaStream: true
  });
};

export const storeSocialLoginData = data => {
  return setData({
    key: "socialMediaAuthentication",
    data
  });
};

export const storeExternalOrderSelected = data => {
  return setData({
    key: "externalPendingOrderSelected",
    data
  });
};

export const storeExternalOrderCustomerInfo = data => {
  return setData({
    key: "customerInfo",
    data
  });
};

export const storeSocialMultipleEmails = data => {
  return setData({
    key: "socialMediaMultipleEmails",
    data
  });
};

// fetch data to display payment option for upfront payment and card update payment
export const fetchUpfrontPaymentDetails = ({ token, ...params }, callback) => {
  return fetchRequested({
    key: "paymentDetails",
    base: BASE.PAYMENTS,
    params,
    headers: {
      "x-oms-token": token
    },
    path: UPFRONT_PAYMENT,
    method: "POST",
    callback
  });
};

export const saveAndGetPaymentCardDetails = (headers, params, callback) => {
  return fetchRequested({
    key: "paymentDetails",
    base: BASE.PAYMENTS,
    params,
    headers,
    path: SAVE_AND_GET_CARD_DETAILS_CXOS,
    method: "POST",
    version: "v4",
    callback
  });
};

// process payment for upfront payment and update card payment
export const processUpfrontPayment = ({ token, ...params }, callback) => {
  return fetchRequested({
    key: "processPayment",
    base: BASE.PAYMENTS,
    params,
    headers: {
      "x-oms-token": token
    },
    path: PROCESS_PAYMENT_METHOD,
    method: "POST",
    callback
  });
};

export const processCardUpdatePayment = (
  { token, ...params },
  callback,
  version
) => {
  /* 
  TODO: japan doesn't use the v4 version of the payment's api, `payment/save_and_get_card_details`. Hence we are using v3
        for Singapore until v4 of the payment service deployed to singapore.
  */
  if (version === "v3") {
    return fetchRequested({
      key: "processPayment",
      base: BASE.PAYMENTS,
      params,
      path: PROCESS_CARD_UPDATE_PAYMENT_METHOD,
      method: "POST",
      version: "v3",
      callback
    });
  }

  return fetchRequested({
    key: "processPayment",
    base: BASE.PAYMENTS,
    params,
    headers: {
      "x-oms-token": token
    },
    path: PROCESS_CARD_UPDATE_PAYMENT_METHOD,
    method: "POST",
    callback
  });
};

export const fetchPaymentStatus = (params, callback) => {
  return fetchRequested({
    key: "paymentStatus",
    base: BASE.PAYMENTS,
    params,
    version: "v4",
    path: PAYMENT_TRANSACTION_STATUS,
    method: "GET",
    callback
  });
};

export const fetchPaymentStatusCXOS = (params, callback) => {
  return fetchRequested({
    key: "paymentStatus",
    base: BASE.PAYMENTS,
    params,
    path: PAYMENT_TRANSACTION_STATUS_CXOS,
    method: "GET",
    callback
  });
};

export const fetchTelcoUserProfile = (headers, callback) => {
  return fetchRequested({
    key: "telcoUserProfile",
    base: BASE.MOBILE_API,
    headers,
    path: TELCO_PROFILE,
    method: "GET",
    callback
  });
};

export const userLogout = (headers, params, callback) => {
  return fetchRequested({
    key: "userLogout",
    base: BASE.USER_SERVICE,
    headers,
    params,
    path: USER_SERVICE_LOGOUT,
    method: "POST",
    callback
  });
};

export const fetchAgreementForm = (headers, params, callback) => {
  return fetchRequested({
    key: "contractualAgreement",
    base: BASE.API_GATEWAY,
    headers,
    params,
    path: API_GATEWAY_DOWNLOAD_SERVICE_AGREEMENT,
    method: "GET",
    callback,
    mediaStream: true,
    base64conversion: false
  });
};

export const emailAgreementForm = callback => {
  return fetchRequested({
    key: "emailAgreementForm",
    base: BASE.TELCO_SERVICE,
    path: TELCO_EMAIL_SERVICE_AGREEMENT,
    method: "POST",
    callback
  });
};

export const cancelPortOutRequest = (params, callback) => {
  return fetchRequested({
    key: "cancelPortOut",
    base: BASE.TELCO_SERVICE,
    path: CREATE_PORTOUT_REQUEST,
    method: "PATCH",
    callback,
    params
  });
};

export const cancelPortInRequest = (params, headers, orderRef, callback) => {
  return fetchRequested({
    base: BASE.PORTIN,
    key: "cancelPortIn",
    path: CANCEL_PORTIN.replace("{orderRef}", orderRef),
    method: "PATCH",
    version: "v1",
    headers,
    callback,
    params
  });
};

export const submitScheduleDeliveryNewSim = (params, callback) => {
  const path = USE_API_GATEWAY
    ? API_GATEWAY_SUBMIT_DELIVERY
    : OMS_SUBMIT_DELIVERY;
  const base = USE_API_GATEWAY ? BASE.API_GATEWAY : BASE.OMS;

  return fetchRequested({
    key: "submitScheduleDelivery",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};
export const fetchEligibleServices = (headers, params, callback) => {
  const path = QUILT_ELIGIBILITY.replace("{sin_number}", params);
  return fetchRequested({
    key: "eligibilitySettings",
    base: BASE.QUILT_SERVICE,
    path,
    method: "GET",
    headers,
    callback,
    override: true
  });
};

export const requestReversePortin = (headers, params, callback) => {
  return fetchRequested({
    key: "requestReversePortin",
    base: BASE.TELCO_SERVICE,
    path: REVERSE_PORTIN,
    method: "POST",
    headers,
    params,
    callback
  });
};

export const submitOrderCancellation = (
  headers,
  params,
  orderRef,
  callback
) => {
  const path = API_GATEWAY_ORDER_CANCELLATION.replace("{order_ref}", orderRef);
  const base = BASE.CXOMS;
  return fetchRequested({
    key: "submitOrderCancellation",
    base,
    path,
    method: "POST",
    params,
    headers,
    callback
  });
};
export const postTerminateNumberRequest = (headers, params, callback) => {
  const path = USE_API_GATEWAY
    ? TELCO_REQUEST_TERMINATE
    : OMS_SUBMIT_TERMINATION;
  const base = USE_API_GATEWAY ? BASE.TELCO_SERVICE : BASE.OMS;
  return fetchRequested({
    key: "postTerminateNumberRequest",
    headers,
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const requestToWinback = callback => {
  const path = USE_API_GATEWAY ? QUILT_WINBACK_AGGREGATION : OMS_SUBMIT_WINBACK;
  const base = USE_API_GATEWAY ? BASE.QUILT_SERVICE : BASE.OMS;
  return fetchRequested({
    key: "winback",
    path,
    base,
    method: "GET",
    callback,
    override: true
  });
};

export const cancelTerminationNumber = (params, callback) => {
  const path = USE_API_GATEWAY ? CANCEL_TERMINATION : OMS_CANCEL_TERMINATION;
  const base = USE_API_GATEWAY ? BASE.REWARDS_SERVICE : BASE.OMS;
  return fetchRequested({
    key: "cancelTermination",
    params,
    path,
    base,
    method: "POST",
    callback
  });
};

export const fetchUserKycDetails = (params, callback) => {
  return fetchRequested({
    key: "userKycDetails",
    base: BASE.USER_SERVICE,
    params,
    path: USER_SERVICE_USER_KYC,
    method: "GET",
    callback,
    whitelistedCodes: [400118]
  });
};

export const submitUserKycDetails = (params, callback) => {
  return fetchRequested({
    key: "submitUserKycDetails",
    base: BASE.USER_SERVICE,
    params,
    path: USER_SERVICE_SUBMIT_USER_KYC,
    method: "POST",
    callback
  });
};

export const updatePortInDetails = (params, callback) => {
  return fetchRequested({
    key: "updatePortInDetails",
    base: BASE.API_GATEWAY,
    path: API_GATEWAY_RESUBMIT_PORTIN_DETAILS,
    method: "POST",
    params,
    callback
  });
};

export const reInitiatePortIn = (params, callback) => {
  return fetchRequested({
    key: "reInitiatePortIn",
    params,
    path: TELCO_RE_INITIATE_NUMBER_PORT_IN,
    base: BASE.TELCO_PORT_IN_SERVICE,
    method: "POST",
    callback
  });
};

export const fetchOrderCancellationReasons = (params, callback) => {
  const path = API_GATEWAY_ORDER_CANCELLATION_REASONS;
  const base = BASE.CXOMS;
  return fetchRequested({
    key: "fetchOrderCancellationReasons",
    base,
    path,
    method: "GET",
    params,
    callback
  });
};

export const requestLinkSocialAccount = (params, callback) => {
  return fetchRequested({
    key: "linkSocialAccount",
    base: BASE.USER_SERVICE,
    params,
    path: USER_SERVICE_LINK_SOCIAL,
    method: "POST",
    callback
  });
};

/**
 * This is a special scenario where we need to update the user token which is received
 * in the url params. When the webapp is used in mobile app, mobile app will launch the
 * webview with the auth_token as a query param. In such cases we need to update the state
 * replacing existing auth_token
 *
 * @param {string} accessToken new auth token
 */
export const updateAuthToken = accessToken => {
  return fetchSucceeded({
    key: "userAuthenticate",
    data: { accessToken }
  });
};

export const fetchPopStations = params => {
  return fetchRequested({
    key: "popStations",
    params,
    path: OMS_POP_STATIONS,
    method: "GET"
  });
};

export const resetDistrictList = () => clearData("districtList");

export const resetStreetList = () => clearData("streetList");

export const resetStoreList = () => clearData("storeList");

export const resetOrderTerminationDetails = () =>
  clearData("orderTerminationDetails");

export const fetchValidateSignature = (params, callback) => {
  return fetchRequested({
    key: "validateSignature",
    params,
    path: OMS_VALIDATE_SIGNATURE,
    method: "GET",
    callback
  });
};

export const fetchOutstandingBills = (params, callback) => {
  return fetchRequested({
    key: "outstandingBills",
    params,
    path: OMS_OUTSTANDING_BILLS,
    method: "POST",
    callback
  });
};

export const payOutstandingBills = (params, callback) => {
  return fetchRequested({
    key: "payOutstandingBills",
    params,
    path: OMS_PAY_OUTSTANDING_BILLS,
    method: "POST",
    callback
  });
};

export const mockPaymentCXOS = (params, callback) => {
  return fetchRequested({
    key: "mockPayment",
    base: BASE.MOCK_PAYMENT,
    params,
    path: MOCK_PAYMENT,
    method: "POST",
    callback
  });
};

export const checkTransactionStatus = ({ token, payment_ref }, callback) => {
  return fetchRequested({
    key: "checkTransactionStatus",
    base: BASE.PAYMENTS,
    headers: {
      "x-oms-token": token,
      "x-payment-reference": payment_ref
    },
    path: OMS_CHECK_PAYMENT_STATUS,
    method: "GET",
    callback
  });
};

export const { fetchRequested, fetchSucceeded, fetchFailed } = createActions({
  FETCH_REQUESTED: payload => payload,
  FETCH_SUCCEEDED: payload => payload,
  FETCH_FAILED: payload => payload
});

const fetchRequestedWithCaptcha = params => {
  const miniApp = isMiniApp();
  return fetchRequested({ ...params, captcha: miniApp ? false : true });
};

export const uploadCisForm = (params, callback) => {
  return fetchRequested({
    key: "uploadCisForm",
    path: CIS_REQUEST,
    method: "POST",
    params,
    callback
  });
};

export const uploadCisHRForm = (params, callback) => {
  return fetchRequested({
    key: "uploadCisHRForm",
    path: CIS_REQUEST_HR,
    method: "POST",
    params,
    callback
  });
};

export const uploadCisPartnersForm = (params, callback) => {
  return fetchRequested({
    key: "uploadCisPartnersForm",
    path: CIS_PARTNERS,
    method: "POST",
    params,
    callback
  });
};

export const getCisPartnersField = (params, callback) => {
  const base = USE_REWARDS_CIS ? BASE.REWARDS : BASE.OMS;
  const path = USE_REWARDS_CIS
    ? `${CIS_PARTNERS_REWARDS_FORM_FIELDS}/${params.name}`
    : `${CIS_PARTNERS_CMS_FORM_FIELDS}`;
  params = USE_REWARDS_CIS ? {} : params;

  return fetchRequested({
    key: "cisPartner",
    path,
    method: "GET",
    base,
    params,
    callback
  });
};

export const fetchMyInfoDetails = (params, callback) => {
  return fetchRequested({
    key: "myInfoDetails",
    path: OMS_MYINFO,
    method: "GET",
    params,
    callback
  });
};

export const fetchMyInfoOTPToken = (params, callback) => {
  return fetchRequested({
    key: "myInfoOTPToken",
    path: OMS_MYINFO_OTP,
    method: "POST",
    params,
    callback
  });
};

export const verifyMyInfoOTP = (params, callback) => {
  return fetchRequested({
    key: "verifyMyInfoOTP",
    path: OMS_MYINFO_VERIFY_OTP,
    method: "POST",
    params,
    callback
  });
};

export const updateParentalConsent = (headers, params, callback) => {
  return fetchRequested({
    key: "updateParentalConsent",
    base: BASE.API_GATEWAY,
    path: API_GATEWAY_UPDATE_PARENTAL_CONSENT,
    method: "POST",
    headers,
    params,
    callback
  });
};

export const fetchOutstandingBillsInfo = (params, callback) => {
  return fetchRequested({
    key: "outstandingBillPayments",
    base: BASE.BILLING,
    path: BILL_DETAILS,
    method: "GET",
    params,
    callback,
    override: true
  });
};

export const fetchOutstandingPaymentIntent = (headers, params, callback) => {
  return fetchRequested({
    key: "outstandingBillPaymentIntent",
    base: BASE.BILLING,
    path: BILL_PAYMENT_INTENT,
    method: "POST",
    headers,
    params,
    callback,
    override: true
  });
};

export const fetchOutstandingPaymentStatus = (params, callback) => {
  return fetchRequested({
    key: "outstandingBillPaymentStatus",
    base: BASE.BILLING,
    path: BILL_PAYMENT_STATUS,
    method: "GET",
    params,
    callback,
    override: true
  });
};

export const fetchEmailOtp = (params, callback) => {
  return fetchRequested({
    key: "emailOtp",
    base: BASE.USER_SERVICE,
    params,
    path: USER_SERVICE_EMAIL_OTP,
    method: "POST",
    callback
  });
};

export const validateEmailOtp = (params, callback) => {
  return fetchRequested({
    key: "validateEmailOtp",
    base: BASE.USER_SERVICE,
    params,
    path: USER_SERVICE_VALIDATE_EMAIL_OTP,
    method: "POST",
    callback
  });
};

export const submitManualEkyc = (params, callback) => {
  return fetchRequested({
    key: "manualEkyc",
    base: BASE.USER_SERVICE,
    params,
    path: USER_SERVICE_MANUAL_EKYC,
    method: "POST",
    multiPartForm: true,
    callback
  });
};

export const fetchEkycDetails = (headers, params, callback) => {
  return fetchRequested({
    key: "kyc",
    base: BASE.USER_SERVICE,
    headers,
    params,
    path: USER_SERVICE_KYC_DETAILS,
    method: "GET",
    callback
  });
};

export const fetchEkycConfig = headers => {
  return fetchRequested({
    key: "kycConfig",
    base: BASE.USER_SERVICE,
    path: USER_SERVICE_KYC_CONFIG,
    method: "GET",
    headers
  });
};

export const cancelServiceTermination = (params, callback) => {
  return fetchRequested({
    key: "cancelServiceTermination",
    base: BASE.AOL,
    params,
    path: AOL_CANCEL_TERMINATION,
    method: "PATCH",
    callback
  });
};

export const fetchTerminationReasons = (params, callback) => {
  return fetchRequested({
    key: "terminationReasons",
    base: BASE.AOL,
    params,
    path: AOL_TERMINATION_REASONS,
    method: "GET",
    callback
  });
};

export const requestOtt = (params, headers, callback) => {
  return fetchRequested({
    key: "requestOtt",
    base: BASE.USER_SERVICE,
    headers,
    path: USER_SERVICE_OTT_GENERATE,
    method: "POST",
    params,
    callback
  });
};

export const requestOttResend = (params, callback) => {
  return fetchRequested({
    key: "requestOtt",
    base: BASE.USER_SERVICE,
    path: USER_SERVICE_OTT_RESEND,
    method: "POST",
    params,
    callback
  });
};

export const requestOttNew = (params, headers, callback) => {
  return fetchRequested({
    key: "requestOtt",
    base: BASE.USER_SERVICE_V5,
    headers,
    path: USER_SERVICE_OTT_GENERATE,
    method: "POST",
    params,
    callback
  });
};

export const requestOttResendNew = (params, callback) => {
  return fetchRequested({
    key: "requestOtt",
    base: BASE.USER_SERVICE_V5,
    path: USER_SERVICE_OTT_RESEND,
    method: "POST",
    params,
    callback
  });
};

export const updateUserProfile = (params, headers, callback) => {
  return fetchRequested({
    key: "updateUserProfile",
    base: BASE.USER_SERVICE,
    headers,
    path: USER_SERVICE_UPDATE_USER_PROFILE,
    method: "PUT",
    params,
    callback
  });
};

export const cancelInCompleteOrder = (params, callback) => {
  const path = API_GATEWAY_OMS_CANCEL_INCOMPLETE_ORDER.replace(
    "{order_ref}",
    params
  );
  return fetchRequested({
    key: "cancelIncompleteOrder",
    base: BASE.API_GATEWAY,
    path,
    method: "POST",
    callback
  });
};

export const savedPaymentMethodsAction = id => {
  const path = SAVED_PAYMENT_METHODS.replace("{id}", id);

  return fetchRequested({
    key: "savedPaymentMethods",
    base: BASE.PROFILE_PAYMENT_METHODS_URL,
    path: path,
    method: "GET"
  });
};

export const enabledPaymentMethodsAction = authToken => {
  const path = ENABLED_PAYMENT_METHODS.replace("{recurrent}", "true");
  return fetchRequested({
    key: "enabledPaymentMethods",
    base: BASE.PROFILE_PAYMENT_METHODS_URL,
    path,
    method: "GET",
    override: true
  });
};

export const PaymentMethodToToggleDefaultAction = payload => {
  return setData({
    key: "PaymentMethodIdToToggleDefault",
    data: payload,
    override: true
  });
};

export const setDefaultPaymentMethodAction = payload => {
  const { id, body, authToken } = payload;
  const path = UPDATE_DEFAULT_PAYMENT_METHOD.replace("{id}", id);

  return fetchRequested({
    key: "setDefaultPaymentMethod",
    base: BASE.PROFILE_PAYMENT_METHODS_URL,
    path: path,
    method: "POST",
    headers: { "X-AUTH": authToken },
    params: body
  });
};

export const getIntentForAddStripeCardAction = payload => {
  const { id, body, authToken } = payload;
  const path = ADD_NEW_PAYMENT_METHOD.replace("{id}", id);
  return fetchRequested({
    key: "getIntentForAddStripeCard",
    base: BASE.PROFILE_PAYMENT_METHODS_URL,
    path,
    method: "POST",
    headers: { "X-AUTH": authToken },
    params: body
  });
};

export const clearIntentAction = () => {
  return setData({
    key: "getIntentForAddStripeCard",
    data: {},
    override: true
  });
};

export const addPaymentMethodAction = payload => {
  const { id, body, authToken } = payload;
  const path = ADD_NEW_PAYMENT_METHOD.replace("{id}", id);
  return fetchRequested({
    key: "addPaymentMethod",
    base: BASE.PROFILE_PAYMENT_METHODS_URL,
    path,
    method: "POST",
    headers: { "X-AUTH": authToken },
    params: body
  });
};

export const removePaymentMethodAction = (
  paymentMethodId,
  customerId,
  authToken
) => {
  const path = REMOVE_PAYMENT_METHOD.replace("{id}", customerId);
  return fetchRequested({
    key: "removePaymentMethod",
    base: BASE.PROFILE_PAYMENT_METHODS_URL,
    path,
    method: "POST",
    headers: { "X-AUTH": authToken },
    params: { paymentMethodId }
  });
};

export const PaymentMethodToEditOrRemoveAction = id => {
  return setData({
    key: "paymentMethodIdToEditOrRemove",
    data: id,
    override: true
  });
};

export const fetchPortinDonorTelco = (params, callback) => {
  return fetchRequested({
    key: "portinDonorTelco",
    base: BASE.PORTIN,
    params,
    path: PORTIN_DONOR_TELCO,
    method: "GET",
    callback
  });
};

export const fetchMNPConfigSettings = (params, callback) => {
  return fetchRequested({
    key: "mnpConfig",
    base: BASE.PORTIN,
    params,
    path: PORTIN_MNPCONFIG_TELCO,
    method: "GET",
    callback
  });
};

export const fetchESimDeliveryConfig = (params, callback) => {
  return fetchRequested({
    key: "eSimDeliveryConfig",
    base: BASE.PORTIN,
    params,
    path: E_SIM_DELIVERY_CONFIG,
    method: "GET",
    callback
  });
};

export const fetchSimConfigSettings = (params, callback) => {
  return fetchRequested({
    key: "simConfig",
    base: BASE.JOURNEY_MANAGER_URL,
    path: CONFIGURATION,
    version: "v1",
    method: "GET",
    params,
    callback
  });
};

export const fetchAnalyticsPreferencesConfig = headers => {
  return fetchRequested({
    key: "analyticPreferences",
    base: BASE.USER_SERVICE,
    path: USER_SERVICE_ANALYTICS_PREFERENCES,
    method: "GET",
    headers,
    override: true
  });
};

export const updateAnalyticsPreferencesConfig = (params, callback) => {
  return fetchRequested({
    key: "currentAnalyticPreferences",
    base: BASE.USER_SERVICE,
    path: USER_SERVICE_ANALYTICS_PREFERENCES,
    method: "PUT",
    params,
    callback
  });
};
export const fetchDefaultAnalytics = (params, callback) => {
  return fetchRequested({
    key: "defaultAnalytics",
    path: DEFAULT_ANALYTICS_PREFERENCES,
    base: BASE.USER_SERVICE,
    method: "GET",
    params,
    callback,
    override: true
  });
};

export const fetchNationalityListFromGlobalConfig = headers => {
  return fetchRequested({
    key: "nationalityList",
    base: BASE.USER_SERVICE,
    path: NATIONALITY_LIST,
    method: "GET",
    headers
  });
};

export const createPlanSwitchRequest = (params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "order",
    params,
    path: PLAN_SWITCH_CREATE_REQUEST,
    base: BASE.API_GATEWAY_CXOS,
    method: "POST",
    callback
  });
};

export const createCancelPlanSwitchRequest = (orderRef, params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "planSwitchOrder",
    params,
    path: API_GATEWAY_GET_CANCEL_PLAN_SWITCH_ORDER.replace(
      "{orderRef}",
      orderRef
    ),
    base: BASE.API_GATEWAY_CXOS,
    method: "PUT",
    callback
  });
};

export const fetchPlanSwitchOrderDetails = (params, callback) => {
  const path = QUILT_PLAN_SWITCH_REQUEST_DETAILS;
  const base = BASE.QUILT_SERVICE;
  return fetchRequested({
    key: "planSwitchOrderDetails",
    path,
    base,
    method: "GET",
    params,
    callback,
    override: true
  });
};

export const fetchSimReplacementOrderDetails = (orderRef, callback) => {
  return fetchRequested({
    key: "simReplacementOrderDetails",
    path: API_GATEWAY_GET_ORDER_STATUS.replace("{orderRef}", orderRef),
    base: BASE.API_GATEWAY_CXOS,
    method: "GET",
    callback,
    override: true
  });
};

export const fetchNumberAndDeliverySlotsAvailability = (params, callback) => {
  return fetchRequested({
    key: "numberAndDeliverySlotsAvailability",
    base: BASE.JOURNEY_MANAGER_URL,
    path: LOGISTIC_NUMBER_AND_DELIVERY_SLOT_AVAILABILITY,
    method: "GET",
    version: "v1",
    params,
    callback
  });
};

export const fetchDeliveryFeeSku = (params, callback) => {
  return fetchRequested({
    key: "deliveryFeeSku",
    base: BASE.JOURNEY_MANAGER_URL,
    path: DELIVERY_FEE_SKU.replace("{slotId}", params),
    method: "GET",
    version: "v1",
    callback
  });
};

export const resubmitSimReplacementKyc = (orderRef, params, callback) => {
  return fetchRequestedWithCaptcha({
    key: "simReplacementKycResubmit",
    params,
    path: PLAN_SWITCH_RESUBMIT_KYC.replace("{orderRef}", orderRef),
    base: BASE.API_GATEWAY_CXOS,
    method: "POST",
    callback,
    multiPartForm: true
  });
};

export const fetchPlanAndAddonBenefits = (params, callback) => {
  return fetchRequested({
    key: "planAndAddonBenefits",
    base: BASE.CUSTOMER_MANAGER_URL,
    path: PLAN_ADDON_BENEFITS,
    method: "GET",
    version: "v2",
    params,
    callback
  });
};

export const getAllSystemWidePromotions = (params, callback) => {
  return fetchRequested({
    key: "allSystemWidePromotion",
    base: BASE.CUSTOMER_MANAGER_URL,
    path: ALL_PROMOTIONS,
    params,
    callback,
    override: true
  });
};

export const getPromocodePromotionDetails = (params, callback) => {
  return fetchRequested({
    key: "promocodePromotionDetails",
    base: BASE.CUSTOMER_MANAGER_URL,
    path: ALL_PROMOTIONS,
    params,
    callback,
    override: true
  });
};

export const getSuggestedAddons = (params, callback) => {
  return fetchRequested({
    key: "suggestedAddons",
    base: BASE.CUSTOMER_MANAGER_URL,
    path: SUGGESTED_ADDONS,
    params,
    callback,
    override: true,
    version: "v3"
  });
};

export const setConsentRecord = (concent, authresponse, callback) => {
  return fetchRequested({
    key: "addConsentRecord",
    base: BASE.API_GATEWAY_CXOS_LOCAL,
    path: API_CONSENT_RECODER,
    version: "v5",
    method: "POST",
    callback,
    headers: { "X-AUTH": authresponse, "X-Deviceid": Session.getDeviceId() },
    params: concent
  });
};
export const NewsetConsentRecord = (concent, authresponse, callback) => {
  return fetchRequested({
    key: "addConsentRecord",
    base: BASE.API_GATEWAY_CXOS_LOCAL,
    path: API_CONSENT_RECODER,
    version: "v5",
    method: "POST",
    headers: { "X-AUTH": authresponse, "X-Deviceid": Session.getDeviceId() },
    params: concent
  });
};

export const getPromocodeOrderPreview = (params, callback) => {
  return fetchRequested({
    key: "promocodeOrderPreview",
    base: BASE.CUSTOMER_MANAGER_URL,
    path: ORDER_PREVIEW,
    params,
    callback,
    override: true,
    version: "v1",
    method: "POST"
  });
};

export const validatePromoCode = (params, callback) => {
  return fetchRequested({
    key: "validPromoCode",
    base: BASE.CUSTOMER_MANAGER_URL,
    path: VALIDATE_PROMO_CODES,
    params,
    callback,
    override: true,
    version: "v1",
    method: "POST"
  });
};

export const userGuestSignup = (headers, params, callback) => {
  const path = USER_SERVICE_GUEST_SIGNUP;
  return fetchRequested({
    key: "userAuthenticate",
    guestSignUp: true,
    base: BASE.USER_SERVICE_V5,
    headers,
    params,
    path,
    method: "POST",
    callback,
    version: "v5"
  });
};

export const requestGuestOtt = (params, headers, callback) => {
  return fetchRequested({
    key: "requestGuestOtt",
    base: BASE.USER_SERVICE,
    headers,
    path: USER_SERVICE_OTT_GENERATE,
    method: "POST",
    params,
    callback
  });
};

export const validateGuestOtt = (params, callback) => {
  return fetchRequested({
    key: "validateGuestOtt",
    base: BASE.USER_SERVICE_V5,
    path: USER_SERVICE_GUEST_OTT_VALIDATE,
    method: "POST",
    params,
    callback
  });
};

export const requestGuestOttResend = (params, callback) => {
  return fetchRequested({
    key: "requestGuestOtt",
    isResendOtt: true,
    base: BASE.USER_SERVICE,
    path: USER_SERVICE_OTT_RESEND,
    method: "POST",
    params,
    callback
  });
};

export const submitReKyc = (params, callback) => {
  const path = RE_SUBMIT_KYC_PATH.replace("{order_id}", params);
  params = undefined;
  return fetchRequested({
    key: "reKyc",
    base: BASE.API_RE_KYC,
    path: path,
    method: "POST",
    params,
    callback
  });
};

export const rescheduleshipmentDelivery = (params, callback) => {
  const { rescheduleid, payment } = params;
  const path = LASS_RESCHEDULE_SHIPMENT_DELIVERY.replace(
    "{reschedule-id}",
    rescheduleid
  );
  return fetchRequested({
    key: "paymentRequest",
    path,
    base: BASE.LOGISTIC,
    params: { payment },
    method: "POST",
    callback,
    version: "v1"
  });
};

export const cancelTransaction = (params, callback) => {
  const path = API_GATEWAY_TRANSCTION_CANCEL.replace(
    "{cxt_id}",
    params?.transaction_id
  )
    .replace("{error_code}", params?.error_code)
    .replace("{error_msg}", params?.error_msg);
  return fetchRequested({
    key: "cancelTransaction",
    base: BASE.ONIC_BASE,
    path: path,
    method: "DELETE",
    callback,
    version: "v6"
  });
};
export const fetchSimreplacementPaymentRequest = (params, callback) => {
  const path = OMS_FETCH_PAYMENT_REQUEST;
  const base = BASE.ONIC_BASE;
  return fetchRequestedWithCaptcha({
    key: "paymentRequest",
    path,
    base,
    method: "POST",
    params,
    callback,
    version: "v5"
  });
};

export const fetchPaymentRequest = (params, callback) => {
  const path = OMS_FETCH_PAYMENT_REQUEST;
  const base = BASE.ONIC_BASE;
  return fetchRequestedWithCaptcha({
    key: "paymentRequest",
    path,
    base,
    method: "POST",
    params,
    callback,
    version: "v5"
  });
};

export const fetchSavedPaymentRequest = (params, callback) => {
  const { customer_id } = params;
  const path = SAVED_PAYMENT_METHOD_REQUEST.replace("{id}", customer_id);
  const base = BASE.ONIC_BASE;
  return fetchRequested({
    key: "savedcardpayment",
    path,
    base,
    method: "GET",
    override: true,
    version: "v6",
    callback
  });
};

export const fetchWallateAuthenticate = (params, callback) => {
  const { paymentMethodId } = params;
  const path = WALLET_AUTHENTICATE.replace(
    "{payment-method-id}",
    paymentMethodId
  );
  const base = BASE.ONIC_BASE;
  return fetchRequested({
    key: "wallateAuthencticate",
    path,
    base,
    method: "POST",
    params,
    override: true,
    callback
  });
};

export const addPaymentMethodInstrument = (params, callback) => {
  const { customerId } = params;
  const path = SAVED_PAYMENT_METHODS.replace("{id}", customerId);
  const base = BASE.ONIC_BASE;
  return fetchRequested({
    key: "paymentMethodInstrument",
    path,
    base,
    method: "POST",
    params,
    override: true,
    callback,
    version: "v4"
  });
};

export const fetchModuleLocale = (params, callback) => {
  const path = API_MODULE_LOCALIZATION.replace("{moduleName}", params);
  const base = BASE.ONIC_BASE;
  return fetchRequested({
    key: "locale",
    path,
    base,
    method: "GET",
    meta: { isBypass: true },
    callback,
    version: "v2"
  });
};

export const updateOrderDetails = (orderRef, params, callback) => {
  const path = API_GATEWAY_UPDATE.replace("{orderRef}", orderRef);
  const base = BASE.ONIC_BASE;
  return fetchRequestedWithCaptcha({
    key: "updateorderdetails",
    params,
    path,
    base,
    method: "PUT",
    callback,
    version: "v3" // need to change to "v3"
  });
};

export const updateAddressDetails = (shipmentReferance, params, callback) => {
  const path = ADDRESS_API_GATEWAY_UPDATE.replace(
    "{shipmentReferance}",
    shipmentReferance
  );
  const base = BASE.ONIC_BASE;
  return fetchRequestedWithCaptcha({
    key: "updateshipmentorderdetails",
    params,
    path,
    base,
    method: "PUT",
    callback,
    version: "v2" // need to change to "v3"
  });
};

export const fetchSavedPaymentRequestEnableDisable = (params, callback) => {
  const { customer_id } = params;
  const path = NEW_SAVED_PAYMENT_METHOD_REQUEST.replace("{id}", customer_id);
  const base = BASE.ONIC_BASE;
  return fetchRequested({
    key: "savedcardpayment",
    path,
    base,
    method: "GET",
    override: true,
    version: "v7",
    callback
  });
};

export const updateSelfPickUpLocation = (params, callback) => {
  const path = SELF_PICKUP_LOCATION_UPDATE;
  const base = BASE.ONIC_BASE;
  return fetchRequested({
    key: "updateSelfPickUpLocation",
    params,
    path,
    base,
    method: "PUT",
    callback,
    version: "v1",
    headers: { "Service-Id": "webfront" }
  });
};

export const unsubscribe = (params, callback) => {
  const path = UNSUBSCRIBE;
  const base = BASE.ONIC_DIRECT;
  return fetchRequested({
    key: "unsubscribe",
    params,
    path,
    base,
    method: "PUT",
    callback
  });
};